import { useRef } from "react";

export const useSwitcher = () => {
  const isInTransition = useRef(false);
  const allowNavigation = () => (isInTransition.current = false);
  const disableNavigation = () => (isInTransition.current = true);
  return { allowNavigation, disableNavigation, getCanNavigate: () => !isInTransition.current };
};
